/*
  Sunne v2 – låt temats egen <product-form> sköta köpknappen.

  PROBLEMET. Mätning 8 september 2026, samma produkt och datum:

    Live-temat   klart på 2,9 s, ingen sidladdning (varukorgslådan öppnas)
    v2 (före)    3 000 ms av total tystnad efter klicket, sedan IzyRents egna
                 anrop, klart 4,9 s, plus full omladdning av /cart ≈ 7 s

  ORSAKEN, hittad genom att jämföra temana: live-temat lägger inte i
  varukorgen med en vanlig formulärpost. Det har en egen webbkomponent,
  assets/product-form.js, som fångar submit och gör

      fetch('/cart.js')
      fetch('/cart/add', { Accept: application/javascript,
                           X-Requested-With: XMLHttpRequest,
                           body: formData + sections + sections_url })

  IzyRent hakar i just det anropet och gör hela sitt jobb inuti det. Vår
  bokningssektion i v2 postade formuläret på vanligt vis i stället. Då fanns
  inget anrop att haka i, och appen föll tillbaka på en egen timer på exakt
  3 000 ms.

  LÖSNINGEN ÄR TEMATS EGEN. Vi bygger ingen egen variant – vi lägger tillbaka
  formuläret i den komponent live-temat använder. Efter ändringen: inget
  dödläge i början, ingen sidomladdning på slutet, och varukorgslådan öppnas
  precis som på live. Verifierat på hyra-snowboard, hyra-skidor och hyrskydd:
  raden heter "… - 2 dagar", antal 1, med Date, noteringsfälten och
  __izyrentValidation.

  Komponenten kräver tre saker:
    1. assets/product-form.js laddad (sker från sunne-oppetdagar.liquid)
    2. formuläret har klassen js-product-form
    3. formuläret ligger inuti ett <product-form>-element

  Konstruktorn kör init() bara om elementet redan har barn, vilket det inte
  har när vi skapar det i JavaScript. Därför flyttar vi in formuläret först
  och anropar init() själva.

  VÄNTELÄGET PÅ KNAPPEN. Sektionen sätter klassen is-laddar redan på klicket.
  Förut försvann den av sig själv, eftersom sidan laddades om. Nu stannar vi
  kvar på sidan, så någon måste ta bort den igen: vid färdigt köp, vid fel,
  när webbläsarens egen fältvalidering stoppar submit, och som sista utväg
  efter 15 sekunder.

  PÅ SIKT bör <product-form> skrivas direkt i sections/sunne-produkt-bokning
  .liquid runt formuläret, och is-laddar sättas på submit i stället för på
  klick. Den här filen är samma sak gjord utifrån, så att ändringen kunde
  mätas innan sektionen skrivs om.

  KONTROLL EFTER ÄNDRING. Lägg en hyra i varukorgen och titta i /cart.js.
  Raden ska heta "… - 2 dagar", ha antal 1 och ha egenskaperna Date,
  noteringsfälten och __izyrentValidation. Står det i stället
  "… - Vuxen, från 17 år" med antal 2 har IzyRent inte hakat i.
*/
(function () {
  'use strict';

  function aterstall(form) {
    var knapp = form.querySelector('.sv2-btn');
    if (!knapp) { return; }
    knapp.classList.remove('is-laddar');
    knapp.classList.remove('is-loading');
    knapp.classList.remove('izyAtcLoad');
  }

  function bevaka(vagg, form) {
    var klar = ['on:cart:add', 'on:line-item:change', 'on:cart:error'];
    var i;
    for (i = 0; i < klar.length; i++) {
      vagg.addEventListener(klar[i], function () {
        setTimeout(function () { aterstall(form); }, 400);
      });
    }
    /* invalid bubblar inte – därför capture. */
    form.addEventListener('invalid', function () { aterstall(form); }, true);
    form.addEventListener('submit', function () {
      setTimeout(function () { aterstall(form); }, 15000);
    });
  }

  function koppla() {
    if (!window.customElements || !customElements.get('product-form')) { return false; }

    var formular = document.querySelectorAll('form.sv2-pb__form');
    var i;
    for (i = 0; i < formular.length; i++) {
      var form = formular[i];
      if (form.closest('product-form')) { continue; }

      form.classList.add('js-product-form');

      var vagg = document.createElement('product-form');
      form.parentNode.insertBefore(vagg, form);
      vagg.appendChild(form);

      /* Se kommentaren om konstruktorn i filens huvud. */
      try {
        if (typeof vagg.init === 'function') { vagg.init(); }
      } catch (e) {}

      bevaka(vagg, form);
    }
    return true;
  }

  function start() {
    if (koppla()) { return; }
    /* product-form.js laddas med defer och kan komma efter oss. */
    var forsok = 0;
    var id = setInterval(function () {
      forsok = forsok + 1;
      if (koppla() || forsok > 40) { clearInterval(id); }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();